package com.appsyde.shared.modules.ticket.domain.model

/**
 * Inbox stats for sidebar: counts + météo.
 * V2: weather et weatherPercentDelta viennent de la baseline (%), null = cold start.
 */
data class InboxStats(
    val unread: Int,
    val processedToday: Int,
    val openCount: Int = 0,
    val waitingCount: Int = 0,
    val clarificationsSuggestedCount: Int = 0,
    val weather: String = "normal",
    /** V2: +X ou −X (%), null si pas de baseline. */
    val weatherPercentDelta: Int? = null
)
